import { connect } from 'react-redux';
import {
  highlightBar,
  jira as jiraActions,
  setConcerningMetricsOnly,
  setLatestMetricsOnly,
  setMetricsExpanded,
  setShowBuildComplement,
  setShowSources,
  modal as modalActions
} from '../actions';

import BuildMetricsComponent from '../Components/BuildMetricsComponent.jsx';
import { modals as modalHelpers } from '../helpers';
import {
  getBaselineBuildInfo,
  getCcfNcfBuildPageOrder,
  getConcerningMetricsOnly,
  getLatestMetricsOnly,
  getMetricsExpanded,
  getRelativeMetrics,
  getShowSources,
  getVisibleMetrics
} from '../reducers';

export const mapStateToProps = (state) => {
  return {
    baselineBuildType: getBaselineBuildInfo(state).buildType,
    metricsExpanded: getMetricsExpanded(state),
    latestMetricsOnly: getLatestMetricsOnly(state),
    concerningMetricsOnly: getConcerningMetricsOnly(state),
    metrics: getVisibleMetrics(state),
    metricsLoaded: getRelativeMetrics(state).length > 0,
    ccfNcfOrder: getCcfNcfBuildPageOrder(state),
    showSources: getShowSources(state)
  };
};

export const mapDispatchToProps = dispatch => ({
  setMetricsExpanded: expanded => dispatch(setMetricsExpanded(expanded)),
  setLatestMetricsOnly:
    latestMetricsOnly => dispatch(setLatestMetricsOnly(latestMetricsOnly)),
  setConcerningMetricsOnly:
    concerningMetricsOnly => dispatch(setConcerningMetricsOnly(concerningMetricsOnly)),
  highlightBar: image => dispatch(highlightBar(image)),
  onShowStatsModal: () => dispatch(modalActions.showStatisticsModal(true)),
  refreshScans: () => dispatch(jiraActions.refreshScans()),
  setShowBuildComplement: (show) => dispatch(setShowBuildComplement(show)),
  onOpenConfirm: (metrics, ccfNcfBuildOrder, showSources) => {
    const scanKeys = metrics.map(m => m.scanKey).filter(x => x);
    if (scanKeys.length === 0) {
      return;
    }

    const typesChecked = modalHelpers.getTypesChecked(ccfNcfBuildOrder, showSources);
    dispatch(modalActions.showJiraConfirmModal(true, scanKeys, typesChecked));
  },
  setShowSources:
    show => dispatch(setShowSources(show))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildMetricsComponent);


// WEBPACK FOOTER //
// src/Containers/BuildMetricsContainer.jsx